<div class="modal-header" *ngIf="showAsDialog">
    <h4 class="modal-title">Part Inventory - {{ preferredVendor }}</h4>
</div>
<div class="flex-fill d-flex flex-column">
    <div class="ms-3 mt-2">Last Defined: 10/25/24</div>
    <ul class="mb-1">
        <li>IN STOCK = number of parts that should be physically on the shelf, prior to a build detail being marked as "BUILT"</li>
        <li>ALLOCATED = number of parts needed for orders in NEW status</li>
        <li>PROJECTED INVENTORY = IN STOCK - ALLOCATED</li>
        <li>TOTAL STOCK PENDING (the old WELD SHOP PROJECTED column) = PROJECTED INVENTORY + ON ORDER</li>
    </ul>
    <div class="m-2 grid-fill" [ngStyle]="{ height: showAsDialog ? '600px' : '100%' }" *ngIf="parts">
        <dx-data-grid
            #partsGrid
            [dataSource]="parts"
            keyExpr="id"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onSelectionChanged)="selectionChange($event)"
            (onRowPrepared)="rowPrepare($event)"
            (onCellDblClick)="rowDoubleClick($event)"
            (onOptionChanged)="onOptionChangedShared($event)"
            (onExporting)="onExporting($event)"
        >
            <dxi-column dataField="preferredVendor" width="200"></dxi-column>

            <dxi-column dataField="inStock" caption="InStock" width="80"></dxi-column>
            <dxi-column dataField="projectedInventory" caption="Proj. Inv." width="80"></dxi-column>
            <dxi-column dataField="onOrderNew" caption="Allocated" width="80"></dxi-column>

            <dxi-column dataField="onOrder" caption="PartsOnOrder" width="70" cellTemplate="poTemplate"></dxi-column>

            <dxi-column dataField="onBackOrder" width="70" cellTemplate="poTemplate"></dxi-column>
            <dxi-column dataField="childrenOnOrder" width="70" cellTemplate="partChildrenTemplate"></dxi-column>

            <!-- total stock pending was the old weld shop proj inventory -->
            <dxi-column dataField="weldShopPI" caption="Total Stock Pending" width="80"></dxi-column>
            <dxi-column dataField="onOrderParent" width="70" caption="OnOrder[Parent]"></dxi-column>

            <dxi-column dataField="lastAdjustment" width="70" caption="Adj. Note"></dxi-column>

            <dxi-column dataField="category" width="150"></dxi-column>
            <dxi-column dataField="partNumber" width="210"></dxi-column>
            <dxi-column dataField="description" width="350"></dxi-column>
            <dxi-column dataField="mfgPartNumber" width="100"></dxi-column>
            <dxi-column dataField="mfgDescription" width="100"></dxi-column>
            <dxi-column dataField="cost" width="100" [format]="{ type: 'currency', precision: 4 }" [visible]="canSeeCost"></dxi-column>
            <dxi-column dataField="price" width="100" [format]="{ type: 'currency', precision: 4 }" [visible]="!showAsDialog"></dxi-column>
            <dxi-column dataField="reOrderMinimum" [visible]="!showAsDialog"></dxi-column>
            <dxi-column dataField="reOrderQuantity" [visible]="!showAsDialog"></dxi-column>
            <dxi-column dataField="unitOfMeasure" [visible]="!showAsDialog"></dxi-column>

            <div *dxTemplate="let cell of 'poTemplate'">
                <a [routerLink]="[]" (click)="purchaseOrderDialog(cell.data.id)">{{ cell.value || '' }}</a>
            </div>
            <div *dxTemplate="let cell of 'partChildrenTemplate'">
                <a [routerLink]="[]" (click)="partChildrenDialog(cell.data)">{{ cell.value || '' }}</a>
            </div>

            <dxo-export *ngIf="!showAsDialog" [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-search-panel *ngIf="!showAsDialog" class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-selection [mode]="'multiple'"></dxo-selection>
            <dxo-state-storing [enabled]="!showAsDialog" type="localStorage" storageKey="part-inventory-grid"></dxo-state-storing>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <ng-container *ngIf="!showAsDialog">
                    <button
                        class="btn btn-success"
                        (click)="open(partsGrid.instance.getSelectedRowsData()[0].id)"
                        [disabled]="partsGrid.instance.getSelectedRowsData().length !== 1"
                    >
                        Open
                    </button>
                    <button
                        class="btn btn-secondary ms-2"
                        (click)="addPartPurchase(partsGrid.instance.getSelectedRowsData()[0])"
                        [disabled]="partsGrid.instance.getSelectedRowsData().length !== 1"
                    >
                        Inventory Adjustment
                    </button>
                    <button *ngIf="hasChanges()" class="btn btn-success ms-4" (click)="save()">Save</button>
                </ng-container>
                <button *ngIf="showAsDialog" (click)="toggleVendor()" class="btn btn-sm btn-warning ms-2">
                    {{ showAllVendors ? 'Show Selected Vendor' : 'Show All Vendors' }}
                </button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="parts" class="me-3"
                    ><strong
                        >{{ partsGrid.instance.totalCount() + ' items' }}
                        {{ partsGrid.instance.getSelectedRowsData().length > 0 ? partsGrid.instance.getSelectedRowsData().length + ' selected' : '' }}
                    </strong></span
                >
            </div>
        </dx-data-grid>
    </div>
    <div>
        <dx-toast message="Changes Saved!" type="success" [displayTime]="500" [maxWidth]="300" [position]="'bottom right'" [(visible)]="isToastVisible"> </dx-toast>
    </div>
</div>
<div class="modal-footer" *ngIf="showAsDialog">
    <button class="btn btn-success ms-3" (click)="select()">Save & Close</button>
    <button class="btn btn-secondary ms-1" (click)="cancel()">Cancel</button>
</div>
